//ajax
import { post, get } from "utils/request.js";
/** **********自动注册全局組件 */
import autoInject from "@/plugins/injectComponents"; //全局组件注册器
import globalColor from "@/utils/globalColor"; // ui组件

//注入ui
import injectUI from 'utils/injectUI.js'; // ui组件
//注入路由
import injectRouter from '@/routes';
//注入vuex
import injectState from '@/store';
//接口
import $api from "config/api.config"
//正则
import * as $re from "config/regexp.config"

import mitt from 'mitt'

/** **************全局css管理 */
import "reset-xiaoxi";
import "element-plus/theme-chalk/index.css";
import "layout-xiaoxi";
import "assets/css/elementUi.reset.scss";
import "assets/css/reset.css";
import "assets/css/common.scss";
import "assets/iconfont/iconfont.css";
import "assets/css/public.scss";


/** **************全局自定义指令管理 *************/
import { ElInfiniteScroll } from 'element-plus';
import draggable from './directive/draggable' // directive
import resizable from './directive/resizable' // directive
import hasPermi from './directive/hasPermi' // directive


import { createApp } from 'vue'
import App from './App.vue'

import VueCookies from "vue-cookies";  // 引用cookie
import globalData from '@/utils/globalData'; // ui组件

// import 'default-passive-events' //添加事件管理者passive  解决 Chrome  touchmove 警告
const app = createApp(App);
app.use(autoInject)   // 注册全局组件
app.use(draggable);
app.use(resizable);
app.use(hasPermi);
app.use(ElInfiniteScroll);
app.use(injectUI)  // 注入ui


app.config.globalProperties.$color = globalColor

const bus = mitt()
app.config.globalProperties.$bus = bus //相当于Vue2中的:Vue.prototype.$bus = bus
// 注入路由
const router = injectRouter(app);

// 注入store 状态管理
injectState(app);

//注入全局变量
app.provide('$cookies', VueCookies)
// 注册数据
app.provide('$globalData', globalData)

//接口
app.provide('$api', $api);
//正则
app.provide('$re', $re);
//ajax
app.provide('$post', post);
app.provide('$get', get);

router.isReady().then(() => app.mount('#app'));
